module.exports = __webpack_public_path__ + "static/media/polaris-bold.e48dad0a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/polaris-bold.otf
// module id = ./src/polaris-bold.otf
// module chunks = 0